<mat-sidenav-container autosize class="cipo--height--full">
    <mat-sidenav-content fxLayout="column" class="command-content cipo--height--full cipo--overflow--hidden">
        <div fxLayout.lt-md="column" fxLayoutAlign="center center" class="cipo-bg--white p-b" fxFlex="none">
            <div fxFlex.gt-sm="grow" ngClass.lt-md="cipo--width--full cipo--overflow--auto">
                <ng-content></ng-content>
            </div>
            <div
                fxLayoutGap="16px"
                fxLayoutAlign="end center"
                ngClass.lt-md="cipo--width--full"
                tabindex="-1"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
                @if (!hideReload()) {
                    <button
                        mat-icon-button
                        data-testid="data-list-command-refresh"
                        (click)="refreshTable()"
                        [disabled]="loading()"
                        [title]="'dataListCommand.refresh' | translate"
                        [attr.aria-label]="'dataListCommand.refresh' | translate">
                        <mat-icon aria-hidden="true">refresh</mat-icon>
                    </button>
                }
                @if (!hideSearch()) {
                    <mat-form-field class="cipo-input p-0">
                        <mat-label>{{ "dataListCommand.search" | translate }}</mat-label>
                        <input
                            matInput
                            data-testid="data-list-command-search-input"
                            [formControl]="searchControl"
                            (keydown.enter)="search()"
                            #criteriaInput />
                        @if (searchControl.value) {
                            <button
                                matSuffix
                                [title]="'dataListCommand.clear' | translate"
                                [attr.aria-label]="'dataListCommand.clear' | translate"
                                mat-icon-button
                                data-testid="data-list-command-search-clear"
                                (click)="clearInput()">
                                <mat-icon aria-hidden="true">close</mat-icon>
                            </button>
                        } @else {
                            <mat-icon matSuffix data-testid="data-list-command-search" aria-hidden="true">
                                search
                            </mat-icon>
                        }
                    </mat-form-field>
                    @if (hasGlobalSearch()) {
                        <button
                            mat-icon-button
                            data-testid="data-list-command-global-search"
                            (click)="toggleGlobalSearch()"
                            [title]="
                                isGlobalSearch()
                                    ? ('dataListCommand.offGlobalSearch' | translate)
                                    : ('dataListCommand.onGlobalSearch' | translate)
                            "
                            [attr.aria-label]="
                                isGlobalSearch()
                                    ? ('dataListCommand.offGlobalSearch' | translate)
                                    : ('dataListCommand.onGlobalSearch' | translate)
                            "
                            [disabled]="loading() || !searchControl.value"
                            [color]="isGlobalSearch() ? 'primary' : ''">
                            <mat-icon aria-hidden="true">language</mat-icon>
                        </button>
                    }
                }
                @if (filtersToApply()?.filters?.filterList?.length > 0) {
                    <button
                        mat-icon-button
                        data-testid="data-list-filters-reset"
                        color="warn"
                        (click)="resetFilter()"
                        [attr.aria-label]="'a11y.dataList.resetFilters' | translate"
                        [disabled]="loading()">
                        <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
                    </button>
                }
                @if (!hidefilter()) {
                    <button
                        mat-icon-button
                        data-testid="data-list-filters-advanced"
                        [disabled]="loading()"
                        [title]="'dataListCommand.advancedFilters' | translate"
                        [attr.aria-label]="'dataListCommand.advancedFilters' | translate"
                        (click)="sidenav().toggle()">
                        <mat-icon aria-hidden="true">filter_alt</mat-icon>
                    </button>
                }
                <ng-content select="[cipoCommandActions]" />
            </div>
        </div>
        <div fxFlex="grow" class="cipo--overflow--hidden">
            <!-- This will be removed, use cipoCommandContent -->
            <ng-content select=".data-list" />
            <!-- use this -->
            <ng-content select="[cipoCommandContent]" />
        </div>
    </mat-sidenav-content>

    <mat-sidenav
        [fixedInViewport]="fixedInViewport()"
        position="end"
        class="sidenav"
        [autoFocus]="true"
        [mode]="userStore.isSmallScreen() ? 'over' : 'side'">
        <div class="cipo--height--full p-y-md" [class]="sidenavclass()">
            @if (!tenantStore.loadingSettings()) {
                <app-data-list-filters
                    [filters]="filters()"
                    [(filtersToApply)]="filtersToApply"
                    (closeFilters)="sidenav().toggle()"
                    data-testid="data-list-command-filters"></app-data-list-filters>
            }
        </div>
    </mat-sidenav>
</mat-sidenav-container>
